function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgReplied = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 187",
    style: {
      fill: "none"
    },
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 287",
    d: "M884 112.668a.468.468 0 0 1-.411-.245l-.013-.023a7.973 7.973 0 0 0-6.97-4.107h-.887v2.657a.468.468 0 0 1-.795.335l-5.312-5.155a.467.467 0 0 1 0-.672l5.312-5.157a.469.469 0 0 1 .795.337v2.657a8.918 8.918 0 0 1 8.75 8.905.472.472 0 0 1-.353.455.5.5 0 0 1-.116.013zm-8.75-5.312h1.35a8.914 8.914 0 0 1 6.727 3.068 7.984 7.984 0 0 0-7.77-6.194h-.312a.469.469 0 0 1-.469-.469v-2.016l-4.171 4.047 4.171 4.048v-2.016a.469.469 0 0 1 .469-.469z",
    transform: "translate(-868.968 -98.418)",
    style: {
      fill: "#00a358"
    }
  }));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgReplied, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/replied.17fe2b30.svg";
export { ForwardRef as ReactComponent };